import React, { useState } from 'react';
import api from '../api';
import { useAdminLanguage } from '../AdminLanguageContext';

export default function Announcements() {
  const { copy } = useAdminLanguage();
  const announcementsCopy = copy.announcements;
  const [form, setForm] = useState({ title: '', content: '' });
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState('');

  const handleSend = async (e) => {
    e.preventDefault();
    if (!form.title) return;
    setSending(true);
    setResult('');
    try {
      const res = await api.post('/admin/announcements', form);
      setResult(`✅ ${res.data.message}`);
      setForm({ title: '', content: '' });
    } catch {
      setResult(`❌ ${announcementsCopy.failed}`);
    } finally {
      setSending(false);
    }
  };

  return (
    <div>
      <div className="page-title">{announcementsCopy.title}</div>
      <div className="card" style={{ maxWidth: 640 }}>
        <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 20 }}>{announcementsCopy.cardTitle}</h3>
        <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 20 }}>
          {announcementsCopy.description}
        </p>
        <form onSubmit={handleSend}>
          <div className="form-group">
            <label>{announcementsCopy.titleLabel}</label>
            <input value={form.title} onChange={e => setForm(f => ({ ...f, title: e.target.value }))}
              placeholder={announcementsCopy.titlePlaceholder} />
          </div>
          <div className="form-group">
            <label>{announcementsCopy.contentLabel}</label>
            <textarea value={form.content} onChange={e => setForm(f => ({ ...f, content: e.target.value }))}
              placeholder={announcementsCopy.contentPlaceholder} rows={5} />
          </div>
          {result && (
            <div style={{ padding: '10px 14px', background: result.startsWith('✅') ? '#f0fdf4' : '#fef2f2',
              borderRadius: 8, fontSize: 13, marginBottom: 16,
              color: result.startsWith('✅') ? '#15803d' : '#b91c1c' }}>
              {result}
            </div>
          )}
          <button type="submit" className="btn btn-primary" disabled={sending || !form.title}>
            {sending ? announcementsCopy.sending : `📢 ${announcementsCopy.submit}`}
          </button>
        </form>
      </div>
    </div>
  );
}
